module.exports = __webpack_public_path__ + "static/img/scene-ckjs.772412c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene/scene-ckjs.png
// module id = KmUH
// module chunks = 1